import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { ProductCard } from "../components/ProductCard";
import { PageHeader, Loading } from "../components/PageHeader";

const FILTERS = [
  ["", "All", "all"], ["physical_art", "Originals", "physical"], ["digital_art", "Digital", "digital"],
  ["audio", "Audio", "audio"], ["video", "Video", "video"],
];

export default function Shop() {
  const [params, setParams] = useSearchParams();
  const type = params.get("type") || "";
  const sort = params.get("sort") || "newest";
  const inStock = params.get("in_stock") === "1";
  const [items, setItems] = useState(null);

  useEffect(() => {
    setItems(null);
    api.get("/products", { params: { type: type || undefined, sort, in_stock: inStock || undefined } }).then((r) => setItems(r.data))
      .catch((e) => { setItems([]); toast.error(errMsg(e)); });
  }, [type, sort, inStock]);

  const set = (k, v) => {
    const n = new URLSearchParams(params);
    v ? n.set(k, v) : n.delete(k);
    setParams(n);
  };

  return (
    <div data-testid="shop-page">
      <PageHeader eyebrow="The shop" title="Works for collectors">
        Originals ship from Sabah. Digital prints, soundscapes and films are delivered instantly through secure links.
      </PageHeader>
      <div className="wb-container">
        <div className="flex flex-col gap-6 border-y wb-line py-5 md:flex-row md:items-center md:justify-between">
          <div className="flex flex-wrap gap-2">
            {FILTERS.map(([v, label, id]) => (
              <button
                key={id} onClick={() => set("type", v)} data-testid={`filter-${id}-button`}
                className={`px-4 py-2 text-[0.68rem] uppercase tracking-[0.2em] border transition-colors duration-200 ${type === v ? "border-[color:var(--wb-gold)] text-wb-gold" : "border-transparent muted hover:text-wb-text"}`}
              >
                {label}
              </button>
            ))}
          </div>
          <div className="flex items-center gap-5">
            <label className="flex items-center gap-2 text-xs muted cursor-pointer">
              <input type="checkbox" checked={inStock} onChange={(e) => set("in_stock", e.target.checked ? "1" : "")} data-testid="filter-in-stock-checkbox" className="accent-[#D4AF37]" />
              Available only
            </label>
            <select value={sort} onChange={(e) => set("sort", e.target.value)} className="wb-input !w-auto !py-2 text-xs" data-testid="sort-select">
              <option value="newest">Newest</option>
              <option value="price_asc">Price: low to high</option>
              <option value="price_desc">Price: high to low</option>
            </select>
          </div>
        </div>
        {!items ? <Loading /> : items.length === 0 ? (
          <p className="py-24 text-center muted" data-testid="shop-empty">No works match these filters.</p>
        ) : (
          <div className="grid gap-x-10 gap-y-16 py-14 sm:grid-cols-2 lg:grid-cols-3" data-testid="shop-grid">
            {items.map((p, i) => <ProductCard key={p.id} p={p} index={i} />)}
          </div>
        )}
      </div>
    </div>
  );
}
